import { PageContainer } from '@/components/page/PageContainer';
import { PageSizer, SizerMode } from '@/components/page/PageSizer';
import { SelfTeamMemberDetailsEditForm } from '@/pages/team/teamMember/overview/SelfTeamMemberDetailsEditForm';
import { ReadEmployee, useGetMeQuery, useGetOpenWorkRecordsQuery } from '@/services/gql/graphql.generated';
import { FC } from 'react';
import { useErrorHandler } from 'react-error-boundary';
import { FiEdit } from 'react-icons/fi';
import strings from '../../team/team.translations';
import essStrings from '../ess.translations';
import { EssHeader } from '@/components/ess/EssHeader';

interface TeamMemberDetailsEditProps {}

export const MyProfileEdit: FC<TeamMemberDetailsEditProps> = () => {
  const handleError = useErrorHandler();

  const [{ data: myData, error: myError }] = useGetMeQuery({
    requestPolicy: 'network-only'
  });

  if (myError) {
    handleError(myError);
  }

  const employee = myData?.myEmployee as ReadEmployee;

  const [{ data: shiftData, error: shiftError }] = useGetOpenWorkRecordsQuery({
    variables: {
      args: {
        employeeId: employee.identityId
      }
    },
    requestPolicy: 'network-only',
    pause: employee.identityId
  });

  if (shiftError) {
    handleError(shiftError);
  }

  const breadcrumbs = [
    {
      name: essStrings.myProfile.header,
      to: `/ess/my-profile`
    },
    {
      name: essStrings.myProfile.header,
      to: `/ess/my-profile/edit`
    }
  ];

  return (
    <PageContainer>
      <EssHeader
        title={essStrings.myProfile.editHeader}
        icon={FiEdit}
        breadcrumbs={breadcrumbs}
      />
      ;
      <PageSizer mode={SizerMode.PAGE} className="overflow-auto">
        <SelfTeamMemberDetailsEditForm employee={employee} />
      </PageSizer>
    </PageContainer>
  );
};
